<template>
	<b-container>
		<b-row class="justify-content-between align-items-center">
			<b-col class="order-3">
				<b-button class="float-right" variant="primary" size="sm" @click="pdf">Gerar PDF</b-button>
			</b-col>
			<b-col class="order-2">
				<h1>Tabela de Preços</h1>
			</b-col>
			<b-col class="order-1">
				<b-form inline @submit.prevent>
					<div class="btn-group">
						<label for="inline-form-input-lucro" class="sr-only">Lucro</label>
						<money
							id="inline-form-input-lucro"
							placeholder="Lucro desejado"
							v-bind="lucroOption"
							v-model.lazy="lucroLocal"
							class="money-div money-div-global"
						></money>
						<b-button variant="success" size="sm" type="submit" @click="calcularLucro">Calcular</b-button>
						<b-button variant size="sm" @click="enviarLimpar">Limpar</b-button>
					</div>
				</b-form>
			</b-col>
		</b-row>
		<hr>

		<b-row>
			<b-col :key="categoria.id" v-for="categoria in cp" class="justify-content-center">
				<h2 class="text-center">{{categoria.caminho}}</h2>
				<calc-categoria
					v-bind:categoria="categoria.id"
					@pronto="filhos_prontos"
					v-bind:lucroGlobal="lucro"
					v-bind:limpar="limpar"
				></calc-categoria>
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
import CalcCategoria from "./CalcCategoria";
import * as jsPDF from "jspdf";
import "jspdf-autotable";
import XLSX from "xlsx";
export default {
	name: "tabela-precos",
	data() {
		return {
			limpar: false,
			cp: [],
			recebidos: [],
			categoria_filhos: [],
			lucro: 0,
			lucroLocal: 0,
			lucroGlobal: 0,
			labels: [
				[
					"Ref",
					"Quantidade",
					"Tam. da Arte",
					"Cobertura",
					"Material",
					"Produção",
					"Preço"
				]
			],
			fields: [
				"referencia",
				"quantidade",
				"tamanho_sangria",
				"cobertura",
				"papel",
				"prazo_producao",
				"precoFinal"
			],
			lucroOption: {
				decimal: ",",
				thousands: ".",
				prefix: "",
				suffix: " %",
				precision: 0,
				masked: false
			}
		};
	},
	components: {
		CalcCategoria
	},
	methods: {
		enviarLimpar: function() {
			this.limpar = !this.limpar;
			this.lucroLocal = 0;
		},
		filhos_prontos: function(categoria) {
			this.cp[categoria.id].produtos = categoria.produtos;
		},
		fetchCategoriasPrecos: function() {
			axios
				.get("/categorias/calc/")
				.then(response => (this.cp = response.data))
				.catch(e => window.sendAlert(e.response));
			setTimeout(() => {
				window.loading(false);
			}, 0);
		},
		calcularLucro: function() {
			this.lucroGlobal = this.lucroLocal;
			this.lucro = this.lucroLocal;
		},
		tratamentoColuna: function(coluna, dado) {
			if (coluna === "precoFinal") {
				return (
					"R$ " +
					parseFloat(dado)
						.toFixed(2)
						.toString()
				);
			} else if (coluna === "tamanho_sangria" && dado === "x") return "-";
			return dado;
		},
		xlsx: function() {
			let data = [];
			Object.keys(this.cp).map(categoria => {
				data.push([this.cp[categoria].caminho]);
				data.push(...Array.from(this.labels));
				data.push(
					...this.cp[categoria].produtos.map(produto => {
						return this.fields.map(coluna =>
							this.tratamentoColuna(coluna, produto[coluna])
						);
					})
				);
			});
			const ws = XLSX.utils.aoa_to_sheet(data);
			const wb = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(wb, ws, "Planilha1");
			XLSX.writeFile(wb, "test.xlsx");
		},
		pdf: function() {
			const doc = new jsPDF({
				orientation: "l",
				margin: { top: 40 },
				startY: 30
			});
			Object.keys(this.cp).map(categoria => {
				doc.text(
					this.cp[categoria].caminho,
					10,
					doc.lastAutoTable.finalY + 5 || 10
				);
				doc.autoTable({
					head: this.labels,
					body: this.cp[categoria].produtos.map(produto => {
						return this.fields.map(coluna =>
							this.tratamentoColuna(coluna, produto[coluna])
						);
					})
				});
			});
			doc.save("table.pdf");
		}
	},
	created: function() {
		this.fetchCategoriasPrecos();
		window.loading(true);
	}
};
</script>

<style scoped>
.money-div-global {
	max-width: 4rem;
}
hr {
	margin-bottom: 2rem;
}
h1 {
	font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/loja/vue-components/TabelaPrecos.vue